import { Injectable } from '@angular/core';

import { CodeValue } from '../../shared/models/code-value';

export const PRODUCT_NAMESPACE_RTPC_FIELD = 'eoffer-prd-fn_rtpc.';

export function removeTranslationCode(value: string) {
	const i = value.indexOf('.');
	return i === -1 ? value : value.slice(Math.max(0, i + 1));
}

@Injectable({ providedIn: 'root' })
export class ProductTranslationService {
	private readonly dico = new Map<string, string>();

	add(dicoPart: CodeValue[] | undefined) {
		if (!dicoPart) {
			return;
		}
		for (const entry of dicoPart) {
			this.dico.set(entry.code, entry.value);
		}
	}

	translate(code: string) {
		return this.dico.get(code) || code;
	}
}
